/**
 * Bloomix Theme - Global JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  try {
    initScrollNewsletterPopup();
  } catch (e) {}

  // Initialize cart functionality
  initCart();

  // Initialize product forms
  initProductForms();

  // Initialize quantity selectors
  initQuantitySelectors();

  // Initialize scroll animations
  initScrollAnimations();

  // Initialize mobile menu
  initMobileMenu();

  initCartDrawer();
  initPredictiveSearch();
});

/**
 * 接近页底时显示邮件订阅弹窗（Shopify customer 表单 + 本地存储防抖）
 */
function initScrollNewsletterPopup() {
  if (window.__bloomixSnlInitialized) return;
  var root = document.getElementById('scroll-newsletter-popup');
  if (!root) return;
  if (document.body.classList.contains('template-password')) return;

  var storageKey = 'bloomixNlDismissUntil_v7';

  /** 预览/排障：URL 含 scroll_nl_reset=1 时清除冷却，便于验证弹窗是否正常弹出 */
  try {
    if (/[?&]scroll_nl_reset=1(?:&|$)/.test(window.location.search)) {
      localStorage.removeItem(storageKey);
    }
  } catch (e) {}
  var threshold = parseInt(root.getAttribute('data-scroll-threshold') || '380', 10);
  var dismissDays = parseInt(root.getAttribute('data-dismiss-days') || '10', 10);
  var subscribedDays = parseInt(root.getAttribute('data-subscribed-days') || '45', 10);

  function getUntil() {
    try {
      var v = localStorage.getItem(storageKey);
      if (!v) return 0;
      var n = parseInt(v, 10);
      return isNaN(n) || n < 0 ? 0 : n;
    } catch (e) {
      return 0;
    }
  }

  function setUntil(days) {
    try {
      localStorage.setItem(storageKey, String(Date.now() + days * 86400000));
    } catch (e) {}
  }

  if (Date.now() < getUntil()) return;

  var form = root.querySelector('form');

  window.__bloomixSnlInitialized = true;

  var opened = false;
  var subscribedThisSession = false;
  var pollId = null;
  var ioObserver = null;
  var resizeObserver = null;
  var sentinel = document.getElementById('scroll-newsletter-sentinel');
  var feedback = root.querySelector('[data-scroll-popup-feedback]');
  var successPanel = root.querySelector('[data-scroll-popup-success]');
  var strings =
    window.theme &&
    window.theme.scrollNewsletterPopup &&
    window.theme.scrollNewsletterPopup.strings
      ? window.theme.scrollNewsletterPopup.strings
      : {};

  function detachTriggers() {
    window.removeEventListener('scroll', onScrollRaf, { capture: true });
    document.removeEventListener('scroll', onAnyScroll, { capture: true });
    window.removeEventListener('resize', onScrollRaf);
    if (ioObserver) {
      ioObserver.disconnect();
      ioObserver = null;
    }
    if (pollId !== null) {
      window.clearInterval(pollId);
      pollId = null;
    }
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  }

  function openPopup() {
    if (opened) return;
    if (Date.now() < getUntil()) return;
    opened = true;
    detachTriggers();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-newsletter-popup--open');
    var email = form ? form.querySelector('input[type="email"]') : null;
    if (email) {
      setTimeout(function() {
        try {
          email.focus();
        } catch (err) {}
      }, 200);
    }
  }

  function closePopup() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-newsletter-popup--open');
    if (!subscribedThisSession) {
      setUntil(dismissDays);
    }
  }

  function docScrollMetrics() {
    var se = document.scrollingElement || document.documentElement;
    var body = document.body;
    var scrollTop = window.pageYOffset != null ? window.pageYOffset : se.scrollTop || (body && body.scrollTop) || 0;
    var winH = window.innerHeight || se.clientHeight || (body && body.clientHeight) || 0;
    var docH = Math.max(
      se.scrollHeight || 0,
      body ? body.scrollHeight : 0,
      se.offsetHeight || 0,
      body ? body.offsetHeight : 0
    );
    return { scrollTop: scrollTop, winH: winH, docH: docH };
  }

  function checkScroll() {
    if (opened) return;
    if (Date.now() < getUntil()) return;
    var m = docScrollMetrics();
    if (m.scrollTop + m.winH >= m.docH - threshold) {
      openPopup();
    }
  }

  var ticking = false;
  function onScrollRaf() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      ticking = false;
      checkScroll();
    });
  }

  function onAnyScroll() {
    onScrollRaf();
  }

  // 主触发：页底哨兵进入视口；rootMargin 扩大底部检测区，提前约 400px 弹出
  if (sentinel && typeof IntersectionObserver !== 'undefined') {
    ioObserver = new IntersectionObserver(
      function(entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            openPopup();
            return;
          }
        }
      },
      {
        root: null,
        rootMargin: '0px 0px 400px 0px',
        threshold: [0, 0.01]
      }
    );
    ioObserver.observe(sentinel);
  }

  window.addEventListener('scroll', onScrollRaf, { passive: true, capture: true });
  document.addEventListener('scroll', onAnyScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScrollRaf, { passive: true });
  window.addEventListener('load', function() {
    requestAnimationFrame(checkScroll);
  });
  window.addEventListener('pageshow', function(ev) {
    requestAnimationFrame(checkScroll);
  });
  checkScroll();

  /* 首屏短时轮询：避免图片/fonts 拉高页面高度后错过唯一一次滚动检测 */
  var pollLeft = 25;
  pollId = window.setInterval(function() {
    if (opened || --pollLeft < 0) {
      window.clearInterval(pollId);
      pollId = null;
      return;
    }
    checkScroll();
  }, 400);

  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(function() {
      if (opened) return;
      requestAnimationFrame(checkScroll);
    });
    try {
      resizeObserver.observe(document.documentElement);
      if (document.body) resizeObserver.observe(document.body);
    } catch (e) {}
  }

  root.querySelectorAll('[data-scroll-popup-close]').forEach(function(el) {
    el.addEventListener('click', function() {
      closePopup();
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      closePopup();
    }
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      if (feedback) {
        feedback.hidden = true;
        feedback.textContent = '';
      }

      var action = form.getAttribute('action') || '/contact';
      var fd = new FormData(form);

      fetch(action, {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function(res) {
          if (submitBtn) submitBtn.disabled = false;
          if (res.ok) {
            subscribedThisSession = true;
            setUntil(subscribedDays);
            form.setAttribute('hidden', '');
            if (successPanel) successPanel.removeAttribute('hidden');
          } else {
            if (feedback) {
              feedback.textContent = strings.error || 'Error';
              feedback.removeAttribute('hidden');
            }
          }
        })
        .catch(function() {
          if (submitBtn) submitBtn.disabled = false;
          if (feedback) {
            feedback.textContent = strings.error || 'Error';
            feedback.removeAttribute('hidden');
          }
        });
    });
  }
}

/**
 * Cart Functionality
 */
function initCart() {
  // Update cart count
  updateCartCount();

  // Listen for cart updates
  if (window.theme.PubSub) {
    window.theme.PubSub.subscribe(window.theme.CartEvents.UPDATED, function(cart) {
      updateCartCount(cart.item_count);
      showNotification('Cart updated', 'success');
    });
  }
}

function updateCartCount(count) {
  if (count === undefined) return;

  const cartCountElements = document.querySelectorAll('[data-cart-count]');
  cartCountElements.forEach(function(el) {
    el.textContent = count;
    el.classList.toggle('cart-count--visible', count > 0);
    el.classList.add('cart-count--updated');
    setTimeout(function() {
      el.classList.remove('cart-count--updated');
    }, 300);
  });
}

function escapeHtml(text) {
  if (text == null) return '';
  var d = document.createElement('div');
  d.textContent = String(text);
  return d.innerHTML;
}

function escapeAttr(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;');
}

function getCartDrawerStrings() {
  return window.theme && window.theme.cartDrawerStrings ? window.theme.cartDrawerStrings : {};
}

function buildCartDrawerBodyHTML(cart) {
  var s = getCartDrawerStrings();
  if (!cart.items || cart.items.length === 0) {
    return (
      '<div class="cart-drawer__empty">' +
      escapeHtml(s.empty || 'Your cart is empty') +
      '<br><a href="/collections/all">' +
      escapeHtml(s.continue_shopping || 'Continue shopping') +
      '</a></div>'
    );
  }
  var html = '';
  cart.items.forEach(function(item, index) {
    var line = index + 1;
    var imgSrc = item.image ? escapeHtml(item.image) : '';
    var productUrl = item.url ? String(item.url).trim() : '';
    var productHref = productUrl ? escapeAttr(productUrl) : '';
    var titleEscaped = escapeHtml(item.product_title || item.title);
    var imgAlt = escapeAttr(item.product_title || item.title || '');
    var imgInner =
      '<img class="cart-drawer__item-img" src="' +
      imgSrc +
      '" alt="' +
      imgAlt +
      '" width="72" height="72">';
    var imgTag = imgSrc
      ? productHref
        ? '<a href="' + productHref + '" class="cart-drawer__item-img-link">' + imgInner + '</a>'
        : imgInner
      : '<div class="cart-drawer__item-img"></div>';
    var vendor = item.vendor
      ? '<div class="cart-drawer__item-vendor">' + escapeHtml(item.vendor) + '</div>'
      : '';
    var titleHtml = productHref
      ? '<a href="' + productHref + '" class="cart-drawer__item-title-link">' + titleEscaped + '</a>'
      : titleEscaped;
    var variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
    var unit = '<p class="cart-drawer__item-unit">' + formatMoney(item.final_price) + '</p>';
    var lineTotal =
      '<span class="cart-drawer__item-line-total">' + formatMoney(item.final_line_price) + '</span>';
    var qtyControls =
      '<div class="cart-drawer__item-actions">' +
      '<div class="cart-drawer__qty" data-cart-drawer-line-wrap data-line="' +
      line +
      '" data-quantity="' +
      item.quantity +
      '">' +
      '<button type="button" data-drawer-qty-delta="-1" aria-label="Decrease">−</button>' +
      '<span>' +
      item.quantity +
      '</span>' +
      '<button type="button" data-drawer-qty-delta="1" aria-label="Increase">+</button>' +
      '</div>' +
      '<button type="button" class="cart-drawer__remove" data-cart-drawer-remove data-line="' +
      line +
      '" aria-label="Remove">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
      '</button>' +
      '</div>';
    html +=
      '<div class="cart-drawer__item" data-cart-drawer-item>' +
      imgTag +
      '<div class="cart-drawer__item-main">' +
      '<div class="cart-drawer__item-top">' +
      '<div>' +
      vendor +
      '<h3 class="cart-drawer__item-title">' +
      titleHtml +
      '</h3>' +
      variant +
      unit +
      '</div>' +
      lineTotal +
      '</div>' +
      qtyControls +
      '</div></div>';
  });
  return html;
}

function buildCartDrawerFooterHTML(cart) {
  var s = getCartDrawerStrings();
  var html = '';
  html +=
    '<details class="cart-drawer__note"><summary>' +
    escapeHtml(s.order_note || '') +
    '</summary><textarea data-cart-drawer-note placeholder="' +
    escapeAttr(s.order_note_placeholder || '') +
    '">' +
    escapeHtml(cart.note || '') +
    '</textarea></details>';

  var discountApps = cart.cart_level_discount_applications || [];
  var cartLevelAllocatedSum = 0;
  discountApps.forEach(function(app) {
    var raw = app.total_allocated_amount != null ? Number(app.total_allocated_amount) : 0;
    cartLevelAllocatedSum += raw;
  });

  if (discountApps.length > 0) {
    if (cartLevelAllocatedSum > 0) {
      discountApps.forEach(function(app) {
        var title = app.title || (app.discount_application && app.discount_application.title) || '';
        var amount = app.total_allocated_amount != null ? app.total_allocated_amount : 0;
        html +=
          '<div class="cart-drawer__discount-row">' +
          '<span>' +
          escapeHtml(title) +
          '</span> <span>(-' +
          formatMoney(amount) +
          ')</span></div>';
      });
    } else if (cart.total_discount > 0) {
      if (discountApps.length === 1) {
        var single = discountApps[0];
        var singleTitle =
          single.title || (single.discount_application && single.discount_application.title) || 'Discount';
        html +=
          '<div class="cart-drawer__discount-row">' +
          '<span>' +
          escapeHtml(singleTitle) +
          '</span> <span>(-' +
          formatMoney(cart.total_discount) +
          ')</span></div>';
      } else {
        html +=
          '<div class="cart-drawer__discount-row"><span>Discount</span> <span>(-' +
          formatMoney(cart.total_discount) +
          ')</span></div>';
      }
    }
  } else if (cart.total_discount > 0) {
    html +=
      '<div class="cart-drawer__discount-row"><span>Discount</span> <span>(-' +
      formatMoney(cart.total_discount) +
      ')</span></div>';
  }

  html += '<div class="cart-drawer__total-row">';
  html +=
    '<span class="cart-drawer__total-label">' +
    escapeHtml(s.estimated_total || 'Estimated total') +
    '</span>';
  html +=
    '<span class="cart-drawer__total-amount">' +
    formatMoney(cart.total_price) +
    ' ' +
    escapeHtml(cart.currency || '') +
    '</span>';
  html += '</div>';
  html +=
    '<p class="cart-drawer__tax-note">' +
    escapeHtml(s.tax_note || '') +
    '</p>';
  html +=
    '<button type="button" class="cart-drawer__checkout" data-cart-drawer-checkout>' +
    escapeHtml(s.checkout || 'Check out') +
    '</button>';
  return html;
}

// 把节流队列里待发的 quantity 应用到 cart 数据上，避免服务器响应的旧 quantity
// 覆盖用户已经点击的最新数字，造成 "5→6→7→8→9→10 然后回跳到 6" 闪烁。
function applyPendingQuantitiesToCart(cart) {
  if (!cart || !cart.items) return cart;
  var delta = 0;
  // 反向遍历，splice 删除时不会扰乱前面索引
  for (var i = cart.items.length - 1; i >= 0; i--) {
    var lineKey = String(i + 1);
    if (Object.prototype.hasOwnProperty.call(pendingLineChanges, lineKey)) {
      var pendingQty = pendingLineChanges[lineKey];
      var oldQty = cart.items[i].quantity || 0;
      if (pendingQty <= 0) {
        cart.items.splice(i, 1);
        delta -= oldQty;
      } else {
        cart.items[i].quantity = pendingQty;
        delta += (pendingQty - oldQty);
      }
    }
  }
  // 同步 item_count，避免 header cart badge 同样回跳
  cart.item_count = Math.max(0, (cart.item_count || 0) + delta);
  // pendingAdds 里的 quantity 也算进 badge
  pendingAdds.forEach(function(p) { cart.item_count += (p.quantity || 0); });
  return cart;
}

function renderCartDrawer(cart) {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  var body = root.querySelector('[data-cart-drawer-body]');
  var footer = root.querySelector('[data-cart-drawer-footer]');
  if (!body || !footer) return;
  // 用 pending 状态覆盖服务器快照里的 quantity（保 UI 数字稳定）
  applyPendingQuantitiesToCart(cart);
  updateCartCount(cart.item_count);
  body.innerHTML = buildCartDrawerBodyHTML(cart);
  var hasPending = Object.keys(pendingLineChanges).length > 0 || pendingAdds.length > 0;
  if ((!cart.items || cart.items.length === 0 || cart.item_count === 0) && !hasPending) {
    footer.hidden = true;
    footer.innerHTML = '';
  } else {
    footer.hidden = false;
    footer.innerHTML = buildCartDrawerFooterHTML(cart);
  }
}

function openCartDrawer() {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  root.classList.add('is-open');
  root.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-drawer-open');
}

function closeCartDrawer() {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  root.classList.remove('is-open');
  root.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-drawer-open');
}

function refreshCartDrawerFromServer() {
  return fetch('/cart.js')
    .then(parseCartJsonResponse)
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
}

function cartDrawerChangeLine(line, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
    .then(parseCartJsonResponse)
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
}

/* =============================================================
   Cart 请求节流 / 串行化
   原因：每次点击立即 fetch 会触发 Shopify bot 防护和 rate limit，
   返回 HTML 错误页导致 "Unexpected token '<'" / "Unable to add to cart"。
   策略：
     - 全局一个 cart op 队列，同一时间只有一个 fetch 在飞
     - 同一 line 的连续 change 合并成最终目标 quantity
     - 同一 variantId 的连续 add 累加 quantity
     - 失败时清空 pending 并 refresh 真实状态
   ============================================================= */
var cartOpInFlight = false;
var pendingLineChanges = {};   // { line: targetQty }
var pendingAdds = [];          // [{ variantId, quantity }]

function scheduleLineChange(line, qty) {
  // 立即更新数字显示和 cart-count，给用户即时反馈
  var wrap = document.querySelector('[data-cart-drawer-line-wrap][data-line="' + line + '"]');
  if (wrap) {
    var prevQty = parseInt(wrap.getAttribute('data-quantity'), 10) || 0;
    wrap.setAttribute('data-quantity', String(qty));
    var num = wrap.querySelector('span');
    if (num) num.textContent = qty;
    // cart-count 同步
    var countNode = document.querySelector('[data-cart-count]');
    if (countNode) {
      var cur = parseInt(countNode.textContent, 10) || 0;
      var next = Math.max(0, cur + (qty - prevQty));
      countNode.textContent = next;
      if (next > 0) countNode.classList.add('cart-count--visible');
    }
  }
  pendingLineChanges[line] = qty;
  drainCartOps();
}

function scheduleAdd(variantId, quantity) {
  // 累加到已存在的同 variant pending，否则新增
  var found = null;
  for (var i = 0; i < pendingAdds.length; i++) {
    if (String(pendingAdds[i].variantId) === String(variantId)) {
      found = pendingAdds[i];
      break;
    }
  }
  if (found) found.quantity += quantity;
  else pendingAdds.push({ variantId: variantId, quantity: quantity });
  // 立即 cart-count +
  var countNode = document.querySelector('[data-cart-count]');
  if (countNode) {
    var cur = parseInt(countNode.textContent, 10) || 0;
    countNode.textContent = cur + quantity;
    countNode.classList.add('cart-count--visible');
  }
  drainCartOps();
}

function setCartLoading(isLoading) {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.toggle('is-loading', !!isLoading);
}

function drainCartOps() {
  if (cartOpInFlight) return;
  // 优先处理 adds（用户感知最强），再处理 changes
  if (pendingAdds.length) {
    var item = pendingAdds.shift();
    cartOpInFlight = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: item.variantId, quantity: item.quantity }] })
    })
      .then(parseCartJsonResponse)
      .then(function() { return refreshCartDrawerFromServer(); })
      .catch(function(err) {
        console.error('Cart add failed:', err);
        pendingLineChanges = {};
        pendingAdds = [];
        refreshCartDrawerFromServer().catch(function() {});
        var msg = err && (err.description || err.message);
        if (!msg || /unexpected token/i.test(msg) || /unable to parse/i.test(msg)) {
          msg = 'Unable to add to cart. Please refresh the page and try again.';
        }
        showNotification(msg, 'error');
      })
      .then(function() {
        cartOpInFlight = false;
        drainCartOps();
      });
    return;
  }
  var lines = Object.keys(pendingLineChanges);
  if (lines.length === 0) {
    setCartLoading(false);
    return;
  }
  var line = parseInt(lines[0], 10);
  var qty = pendingLineChanges[lines[0]];
  delete pendingLineChanges[lines[0]];
  cartOpInFlight = true;
  setCartLoading(true);
  cartDrawerChangeLine(line, qty)
    .catch(function(err) {
      console.error('Cart change failed:', err);
      pendingLineChanges = {};
      refreshCartDrawerFromServer().catch(function() {});
      var msg = err && (err.description || err.message);
      if (!msg || /unexpected token/i.test(msg) || /unable to parse/i.test(msg)) {
        msg = 'Cart update failed. Please refresh the page and try again.';
      }
      showNotification(msg, 'error');
    })
    .then(function() {
      cartOpInFlight = false;
      // 还有 pending 就继续转，否则关掉 spinner
      if (Object.keys(pendingLineChanges).length === 0 && pendingAdds.length === 0) {
        setCartLoading(false);
      }
      drainCartOps();
    });
}

var cartDrawerNoteTimer;
function initCartDrawer() {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  // 全局：任意带 [data-cart-open] 的元素点击拉起 drawer（如 header 购物车 icon）
  // 打开前先 fetch /cart.js 渲染当前购物车内容，否则首次打开会是空的
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    e.preventDefault();
    openCartDrawer();
    refreshCartDrawerFromServer().catch(function(err) {
      console.error('Failed to load cart on open:', err);
    });
  });

  // 页面加载时也预拉一次购物车数据，让 drawer 有内容随时可显示
  refreshCartDrawerFromServer().catch(function(err) {
    console.error('Failed to preload cart:', err);
  });

  root.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
    var checkoutBtn = e.target.closest('[data-cart-drawer-checkout]');
    if (checkoutBtn) {
      e.preventDefault();
      var nativeUrl = (window.theme && window.theme.routes && window.theme.routes.checkout) || '/checkout';
      // Route through the Antom middleware when enabled; otherwise native checkout.
      if (typeof window.nxAntomCheckout === 'function' && window.nxAntomEnabled && window.nxAntomEnabled()) {
        closeCartDrawer();
        window.nxAntomCheckout(nativeUrl);
      } else {
        window.location.href = nativeUrl;
      }
      return;
    }
    var deltaBtn = e.target.closest('[data-drawer-qty-delta]');
    if (deltaBtn) {
      e.preventDefault();
      var wrap = deltaBtn.closest('[data-cart-drawer-line-wrap]');
      if (!wrap) return;
      var line = parseInt(wrap.getAttribute('data-line'), 10);
      var qty = parseInt(wrap.getAttribute('data-quantity'), 10);
      var delta = parseInt(deltaBtn.getAttribute('data-drawer-qty-delta'), 10);
      var newQty = qty + delta;
      if (newQty < 0) newQty = 0;
      scheduleLineChange(line, newQty);
      return;
    }
    var removeBtn = e.target.closest('[data-cart-drawer-remove]');
    if (removeBtn) {
      e.preventDefault();
      var lineR = parseInt(removeBtn.getAttribute('data-line'), 10);
      scheduleLineChange(lineR, 0);
    }
  });

  root.addEventListener(
    'input',
    function(e) {
      if (!e.target.matches('[data-cart-drawer-note]')) return;
      clearTimeout(cartDrawerNoteTimer);
      var val = e.target.value;
      cartDrawerNoteTimer = setTimeout(function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: val })
        }).catch(function() {
          showNotification('Could not save note', 'error');
        });
      }, 500);
    },
    true
  );

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });

  var triggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  triggers.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      refreshCartDrawerFromServer().then(function() {
        openCartDrawer();
      });
    });
  });
}

/**
 * Product Forms
 */
function getVariantIdFromForm(form) {
  var idField = form.querySelector('[name="id"]');
  if (!idField) return '';

  if (idField.tagName === 'SELECT') {
    var selectedOption = idField.options[idField.selectedIndex];
    if (selectedOption && !selectedOption.disabled) {
      return selectedOption.value;
    }

    for (var i = 0; i < idField.options.length; i++) {
      if (!idField.options[i].disabled) {
        idField.selectedIndex = i;
        return idField.options[i].value;
      }
    }
    return '';
  }

  return idField.value || '';
}

function parseCartJsonResponse(response) {
  return response.text().then(function(text) {
    var data;
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      if (text && text.trim().charAt(0) === '<') {
        throw {
          description: 'Unable to add to cart. Please refresh the page and try again.'
        };
      }
      throw {
        description: 'Unexpected response from cart. Please try again.'
      };
    }

    if (!response.ok) {
      throw data;
    }

    return data;
  });
}

function initProductForms() {
  const productForms = document.querySelectorAll('[data-product-form]');

  productForms.forEach(function(form) {
    if (form.dataset.ajaxCartBound === 'true') return;
    form.dataset.ajaxCartBound = 'true';

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (form.dataset.ajaxCartSubmitting === 'true') return;
      form.dataset.ajaxCartSubmitting = 'true';

      const submitButton = e.submitter || form.querySelector('[type="submit"]');
      const originalText = submitButton ? submitButton.innerHTML : '';

      const variantId = getVariantIdFromForm(form);
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;

      if (!variantId) {
        showNotification('This product is unavailable', 'error');
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="loading-spinner"></span> Adding...';
      }

      // ATC 直接发请求，等返回再 open drawer + 改按钮 ✓ Added。
      // 同一 form 已被 ajaxCartSubmitting flag 防重入，所以不会产生本 form 的并发请求；
      // 节流队列只对 +/-/remove 等 drawer 内的高频操作生效。
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: Number(quantity) || 1 }] })
      })
        .then(parseCartJsonResponse)
        .then(function(data) {
          if (data.items || data.id || (Array.isArray(data.items) && data.items.length)) return data;
          throw data;
        })
        .then(function() {
          if (submitButton) submitButton.innerHTML = '✓ Added!';
          // 先把最新购物车数据拉回来 render，再打开 drawer —
          // 这样 drawer 一拉出就有刚加入的商品，没有"开门后才刷新"的卡顿。
          return refreshCartDrawerFromServer().then(function() {
            openCartDrawer();
          });
        })
        .catch(function(error) {
          console.error('Cart add failed:', error);
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.innerHTML = originalText;
          }
          form.dataset.ajaxCartSubmitting = 'false';
          // 如果 error.message 是 JSON 解析失败（"Unexpected token '<'"），说明服务器返回了 HTML
          // 错误页，对用户毫无意义；用友好兜底替换。
          var raw = error && (error.description || error.message);
          if (!raw || /unexpected token/i.test(raw) || /unable to parse/i.test(raw)) {
            raw = 'Unable to add to cart. Please refresh the page and try again.';
          }
          showNotification(raw, 'error');
        })
        .then(function() {
          setTimeout(function() {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.innerHTML = originalText;
            }
            form.dataset.ajaxCartSubmitting = 'false';
          }, 800);
        });
    });
  });
}

/**
 * Quantity Selectors & Cart AJAX Updates
 */
function initQuantitySelectors() {
  document.addEventListener('click', function(e) {
    var btn = e.target;

    if (btn.matches('[data-quantity-plus]')) {
      e.preventDefault();
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      if (!input || !input.dataset.itemKey) return;
      var value = parseInt(input.value) || 0;
      input.value = value + 1;
      updateCartItem(input);
    }

    if (btn.matches('[data-quantity-minus]')) {
      e.preventDefault();
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      if (!input || !input.dataset.itemKey) return;
      var value = parseInt(input.value) || 1;
      if (value > 0) {
        input.value = value - 1;
        updateCartItem(input);
      }
    }

    if (btn.matches('[data-remove-item]') || btn.closest('[data-remove-item]')) {
      e.preventDefault();
      var removeBtn = btn.matches('[data-remove-item]') ? btn : btn.closest('[data-remove-item]');
      var itemKey = removeBtn.dataset.itemKey;
      var input = document.querySelector('[data-quantity-input][data-item-key="' + itemKey + '"]');
      if (input) {
        input.value = 0;
        updateCartItem(input, true);
      }
    }
  });
}

/**
 * AJAX 更新购物车数量并刷新页面数字
 */
function updateCartItem(input, isRemove) {
  var form = input.closest('form');
  if (!form) return;

  var itemRow = input.closest('[data-cart-item]');
  if (itemRow) itemRow.style.opacity = '0.6';

  var allInputs = form.querySelectorAll('[data-quantity-input]');
  var updates = {};
  allInputs.forEach(function(inp) {
    updates[inp.dataset.itemKey] = parseInt(inp.value) || 0;
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ updates: updates })
  })
  .then(parseCartJsonResponse)
  .then(function(cart) {
    if (isRemove || input.value == 0) {
      if (itemRow) itemRow.remove();
      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }
    } else {
      var updatedItem = cart.items.find(function(item) { return item.key === input.dataset.itemKey; });
      if (updatedItem && itemRow) {
        var totalEl = itemRow.querySelector('.cart-item__total-price');
        if (totalEl) totalEl.textContent = formatMoney(updatedItem.final_line_price);

        var originalEl = itemRow.querySelector('.cart-item__original-price');
        if (originalEl) {
          if (updatedItem.original_line_price > updatedItem.final_line_price) {
            originalEl.textContent = formatMoney(updatedItem.original_line_price);
            originalEl.style.display = '';
          } else {
            originalEl.style.display = 'none';
          }
        }
      }
    }

    updateCartSummary(cart);
    updateCartCount(cart.item_count);

    if (itemRow) itemRow.style.opacity = '1';
  })
  .catch(function(err) {
    console.error('Cart update error:', err);
    showNotification('Failed to update cart', 'error');
    if (itemRow) itemRow.style.opacity = '1';
  });
}

/**
 * 刷新右侧价格汇总
 */
function updateCartSummary(cart) {
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price);

  var totalEl = document.querySelector('[data-cart-total]');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

  var discountRow = document.querySelector('.cart-summary__row--discount');
  if (discountRow) {
    if (cart.total_discount > 0) {
      discountRow.style.display = 'flex';
      discountRow.querySelector('span:last-child').textContent = '-' + formatMoney(cart.total_discount);
    } else {
      discountRow.style.display = 'none';
    }
  }
}

/**
 * 金额格式化（分转元）
 */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/**
 * Scroll Animations
 */
function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('[data-animate]');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    animatedElements.forEach(function(el) {
      observer.observe(el);
    });
  }
}

/**
 * Mobile Menu
 */
function initMobileMenu() {
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (!menuToggle || !mobileMenu) return;

  function setOpen(open) {
    mobileMenu.classList.toggle('is-open', open);
    menuToggle.classList.toggle('is-active', open);
    document.body.classList.toggle('menu-open', open);
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (!open && document.activeElement && mobileMenu.contains(document.activeElement)) {
      try {
        menuToggle.focus();
      } catch (e) {}
    }
  }

  menuToggle.addEventListener('click', function(ev) {
    ev.preventDefault();
    var openNext = !mobileMenu.classList.contains('is-open');
    setOpen(openNext);
    if (!openNext) {
      resetMobileMegaNavPanels();
    }
  });

  mobileMenu.querySelectorAll('[data-menu-close]').forEach(function(el) {
    el.addEventListener('click', function() {
      setOpen(false);
      resetMobileMegaNavPanels();
    });
  });

  document.addEventListener('keydown', function(ev) {
    if (ev.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      setOpen(false);
      resetMobileMegaNavPanels();
    }
  });

  initMobileMegaNavPanels();
}

/**
 * Drawer 第二层：编辑器配置的 Mega category 产品列表（左滑切入）
 */
function initMobileMegaNavPanels() {
  var menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  var stack = menu.querySelector('.mega-mob-stack');
  if (!stack || stack.classList.contains('mega-mob-stack--legacy')) return;

  stack.querySelectorAll('[data-mobile-mega-enter]').forEach(function(btn) {
    btn.addEventListener('click', function(ev) {
      ev.preventDefault();
      var bid = btn.getAttribute('data-mobile-mega-enter');
      if (!bid) return;
      stack.querySelectorAll('[data-mobile-mega-panel]').forEach(function(p) {
        p.hidden = true;
      });
      var panel = stack.querySelector('[data-mobile-mega-panel="' + bid.replace(/"/g, '') + '"]');
      if (panel) {
        panel.hidden = false;
        stack.classList.add('is-submenu');
      }
    });
  });

  stack.querySelectorAll('[data-mobile-mega-back]').forEach(function(b) {
    b.addEventListener('click', function(ev) {
      ev.preventDefault();
      resetMobileMegaNavPanels();
    });
  });
}

function resetMobileMegaNavPanels() {
  var menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  var stack = menu.querySelector('.mega-mob-stack');
  if (!stack || stack.classList.contains('mega-mob-stack--legacy')) return;
  stack.classList.remove('is-submenu');
  stack.querySelectorAll('[data-mobile-mega-panel]').forEach(function(p) {
    p.hidden = true;
  });
}

/**
 * 预测搜索浮层（Shopify /search/suggest.json）
 */
function initPredictiveSearch() {
  var root = document.querySelector('[data-predictive-search-root]');
  if (!root) return;

  var input = document.getElementById('PredictiveSearchInput');
  var list = root.querySelector('[data-ps-list]');
  var clearBtn = root.querySelector('[data-ps-clear]');
  var seeAll = root.querySelector('[data-ps-see-all]');
  var seeAllText = root.querySelector('[data-ps-see-all-text]');
  if (!input || !list || !clearBtn || !seeAll) return;

  var searchUrlBase = root.getAttribute('data-search-url') || '/search';
  var strNo = root.getAttribute('data-str-no-results') || '';
  var strLoad = root.getAttribute('data-str-loading') || '…';
  var strSearchFor = root.getAttribute('data-str-search-for') || 'Search for';

  function productThumbUrl(p) {
    var fi = p.featured_image;
    if (!fi) return '';
    if (typeof fi === 'string') return fi;
    if (fi.url) return fi.url;
    return '';
  }

  function extractProducts(data) {
    if (!data) return [];
    if (Array.isArray(data.products)) return data.products;
    var r = data.resources && data.resources.results;
    if (r && Array.isArray(r.products)) return r.products;
    return [];
  }

  function buildSuggestUrl(q) {
    var b = window.routes && window.routes.predictive_search_url
      ? String(window.routes.predictive_search_url)
      : '/search/suggest';
    if (b.indexOf('//') === 0) b = window.location.protocol + b;
    var queryPart = b.indexOf('?') >= 0 ? b.slice(b.indexOf('?')) : '';
    var baseOnly = b.split('?')[0];
    baseOnly = baseOnly.replace(/\/$/, '');
    if (!/\.json$/i.test(baseOnly)) baseOnly += '.json';
    var join = queryPart.indexOf('?') === 0 ? '&' : '?';
    if (!queryPart) join = '?';
    return (
      baseOnly +
      queryPart +
      join +
      'q=' +
      encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=12'
    );
  }

  function closeMobileMenuIfOpen() {
    var mm = document.querySelector('[data-mobile-menu]');
    if (!mm || !mm.classList.contains('is-open')) return;
    mm.classList.remove('is-open');
    mm.setAttribute('aria-hidden', 'true');
    var tg = document.querySelector('[data-menu-toggle]');
    if (tg) {
      tg.classList.remove('is-active');
      tg.setAttribute('aria-expanded', 'false');
    }
    document.body.classList.remove('menu-open');
    if (typeof resetMobileMegaNavPanels === 'function') {
      resetMobileMegaNavPanels();
    }
  }

  function updateClearVisibility() {
    clearBtn.hidden = !input.value || input.value.length === 0;
  }

  var fetchTimer;
  function runFetch() {
    var q = (input.value || '').trim();
    var footerLine = strSearchFor + ' "' + q + '"';
    if (seeAllText) seeAllText.textContent = footerLine;
    var join = searchUrlBase.indexOf('?') >= 0 ? '&' : '?';
    seeAll.setAttribute(
      'href',
      searchUrlBase + join + 'q=' + encodeURIComponent(q)
    );

    clearTimeout(fetchTimer);
    if (!q) {
      list.innerHTML = '';
      return;
    }
    list.innerHTML = '<li class="ps-loading">' + strLoad + '</li>';
    fetchTimer = setTimeout(function() {
      var url = buildSuggestUrl(q);
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function(r) {
          return r.json();
        })
        .then(function(data) {
          var products = extractProducts(data);
          list.innerHTML = '';
          if (!products.length) {
            var em = document.createElement('li');
            em.className = 'ps-empty';
            em.textContent = strNo;
            list.appendChild(em);
            return;
          }
          products.forEach(function(p) {
            var a = document.createElement('a');
            a.className = 'ps-item';
            a.href = p.url || '#';
            var th = document.createElement('div');
            th.className = 'ps-item__thumb';
            var imgU = productThumbUrl(p);
            if (imgU) {
              var im = document.createElement('img');
              im.src = imgU;
              im.alt = '';
              im.width = 96;
              im.height = 96;
              im.loading = 'lazy';
              th.appendChild(im);
            }
            var tit = document.createElement('div');
            tit.className = 'ps-item__title';
            tit.textContent = p.title || '';
            a.appendChild(th);
            a.appendChild(tit);
            var li = document.createElement('li');
            li.appendChild(a);
            list.appendChild(li);
          });
        })
        .catch(function() {
          list.innerHTML = '';
          var em = document.createElement('li');
          em.className = 'ps-empty';
          em.textContent = strNo;
          list.appendChild(em);
        });
    }, 260);
  }

  function openOverlay() {
    closeMobileMenuIfOpen();
    root.removeAttribute('hidden');
    root.classList.add('is-open');
    document.body.classList.add('ps-open');
    updateClearVisibility();
    runFetch();
    setTimeout(function() {
      input.focus();
      try {
        input.select();
      } catch (e) {}
    }, 20);
  }

  function closeOverlay() {
    root.setAttribute('hidden', '');
    root.classList.remove('is-open');
    document.body.classList.remove('ps-open');
    input.value = '';
    list.innerHTML = '';
    clearBtn.hidden = true;
    if (seeAllText) seeAllText.textContent = '';
    seeAll.setAttribute('href', searchUrlBase);
  }

  document.addEventListener('click', function(e) {
    var tr = e.target.closest('[data-predictive-search-trigger]');
    if (!tr) return;
    e.preventDefault();
    openOverlay();
  });

  root.querySelectorAll('[data-ps-close]').forEach(function(el) {
    el.addEventListener('click', function() {
      closeOverlay();
    });
  });

  clearBtn.addEventListener('click', function() {
    input.value = '';
    updateClearVisibility();
    runFetch();
    input.focus();
  });

  input.addEventListener('input', function() {
    updateClearVisibility();
    runFetch();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      closeOverlay();
    }
  });
}

/**
 * Notification System
 */
function showNotification(message, type) {
  const existingNotifications = document.querySelectorAll('.notification');
  existingNotifications.forEach(function(n) { n.remove(); });

  const notification = document.createElement('div');
  notification.className = 'notification notification--' + type;
  notification.innerHTML = `
    <span class="notification__message">${message}</span>
    <button class="notification__close" onclick="this.parentElement.remove()">×</button>
  `;

  document.body.appendChild(notification);

  setTimeout(function() {
    notification.classList.add('is-visible');
  }, 10);

  setTimeout(function() {
    notification.classList.remove('is-visible');
    setTimeout(function() {
      notification.remove();
    }, 300);
  }, 3000);
}

// Add notification styles
const notificationStyles = document.createElement('style');
notificationStyles.textContent = `
  .notification {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 1.5rem 2rem;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 1rem;
    z-index: 10000;
    transform: translateX(120%);
    transition: transform 0.3s ease;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  }

  .notification.is-visible {
    transform: translateX(0);
  }

  .notification--success {
    background: #0ABAB5;
    color: white;
  }

  .notification--error {
    background: #F97316;
    color: white;
  }

  .notification__message {
    font-size: 1.5rem;
    font-weight: 600;
  }

  .notification__close {
    background: none;
    border: none;
    color: inherit;
    font-size: 2rem;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.3s;
  }

  .notification__close:hover {
    opacity: 1;
  }

  .loading-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
document.head.appendChild(notificationStyles);
